import { render } from "./SvgCanvas.vue?vue&type=template&id=42fce650&ts=true"
import script from "./SvgCanvas.vue?vue&type=script&lang=ts"
export * from "./SvgCanvas.vue?vue&type=script&lang=ts"

import "./SvgCanvas.vue?vue&type=style&index=0&id=42fce650&lang=css"

import exportComponent from "C:\\Users\\ga38som\\IdeaProjects\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__